<h3 class="sec-heading" *ngIf="section?.Title">{{section.Title}}</h3>
<p class="projDesc" *ngIf="section?.Description">
    <markdown [data]="section?.Description | replaceSpace | removeImageText"></markdown>
</p>